import styled from 'styled-components'

export const SafeAnimalsPackageTableContainer = styled.div`
  width: 1483px;
  margin: 20px 0px;
`

export const Title = styled.h1`
  font-family: Ubuntu;
  font-size: 18px;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 0.02em;
  text-align: left;
`

export const TitleTableContainer = styled.div`
  font-family: Ubuntu;
  color: #666666;
  font-size: 16px;
  margin: 20px auto;
  max-width: 1300px;
  text-align: left;
`

export const TableContainer = styled.div`
  box-shadow: 0px 40px 40px 0px #0000001a;
  width: 100%;
  margin: 0;
  margin-bottom: 32px;
`

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
`

export const Header = styled.th`
  background-color: #0093b2;
  font-family: Ubuntu, sans-serif;
  font-size: 10px;
  font-weight: 700;
  line-height: 18px;
  letter-spacing: 0.05em;
  text-align: start;
  color: #ffffff;
  padding: 10px 40px;
  width: auto;
`

export const NameHeader = styled(Header)`
  width: 300px;
`

export const ActionsHeader = styled(Header)`
  width: 70px;
  padding: 10px 10px;
`

export const Cell = styled.td`
  font-family: Ubuntu;
  font-size: 14px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0.02em;
  max-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: start;
  padding: 10px 40px;
  color: #646464;
  width: 100%;
`

export const NameCell = styled(Cell)``

export const RaceCell = styled(Cell)``

export const RaceCellContainer = styled.div`
  display: flex;
  gap: 10px;
`

export const RaceName = styled.div``

export const RaceEditIcon = styled.img``

export const AnimalName = styled.div``

export const NamePackPrice = styled.div`
  font-family: Ubuntu;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.02em;
  color: #1f1f1f;
`

export const ActionsCell = styled(Cell)`
  width: 70px;

  text-align: start;
  padding: 8px;
  font-weight: 700;
`

export const Row = styled.tr`
  width: 100%;
`

export const Actions = styled.div`
  display: flex;
  gap: 10px;
`

export const ButtonContainer = styled.span`
  display: flex;
  padding: 2px;
  justify-content: center;
`

export const DeleteButton = styled.img`
  cursor: pointer;
`

export const OpenCollapseButton = styled.img`
  cursor: pointer;
`
export const ExpandedRowContainer = styled.tr``

export const ExpandedRow = styled.td`
  width: 100%;
`
export const ExtraInfo = styled.tr``

export const ExtraInfoData = styled.td``

export const ExtraInfoText = styled.div`
  margin: 10px auto;
  width: 50%;
  font-family: Ubuntu, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0.02em;
  text-align: center;
  color: #646464;
`

export const PackageTable = styled.table`
  border-spacing: 0;
  width: 100%;
`

export const PackageTableRow = styled.tr`
  background-color: #d9f0f466;
  border-spacing: 0px;
`

export const PackageTableTitleRow = styled(PackageTableRow)`
  background-color: #ffffff;
`

export const PackageTableHeader = styled(Header)`
  background-color: #ffffff;
  color: #000000;
  text-align: center;
  border-left: ${(props: any) =>
    props.selected ? '2px solid #F39C12' : 'none'};
  border-right: ${(props: any) =>
    props.selected ? '2px solid #F39C12' : 'none'};
  border-top: ${(props: any) =>
    props.selected ? '2px solid #F39C12' : 'none'};
  padding: 0;
  cursor: pointer;
`

export const PackageTableNameHeader = styled(PackageTableHeader)`
  // width 500px;
  background-color: #ffffff;
`

export const PackageTableCell = styled.td`
  border-left: ${(props: any) => (props.border ? '2px solid #F39C12' : 'none')};
  border-right: ${(props: any) =>
    props.border ? '2px solid #F39C12' : 'none'};
  border-bottom: ${(props: any) =>
    props.border && props.lastItem ? '2px solid #F39C12' : 'none'};
  padding: 5px 40px;
  text-align: left;
  overflow: hidden;
  font-size: 14px;
  border-spacing: 0px;
`

export const PackageTableRowTitleCell = styled(PackageTableCell)`
  text-align: start;
`

export const PackageTableRowTitleCellContainer = styled.div`
  font-family: Ubuntu;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.02em;
  word-wrap: break-word;
  display: flex;
  justify-content: space-between;
`

export const PackageTableRowTitleCellText = styled.div``

export const PackageTableRowTitleCellOpenCloseIcon = styled.img``

export const PackageTableCellTitle = styled.div`
  margin: 20px 0;
  display: flex;
  background-color: #fff;
`

export const PackNameHeader = styled.div`
  font-family: Ubuntu, sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 0.02em;
  text-align: center;
  color: #646464;
  padding: 0 10px;
`

export const PackPriceHeader = styled.div`
  font-family: Ubuntu, sans-serif;
  font-size: 28px;
  font-weight: 400;
  line-height: 36px;
  letter-spacing: 0.02em;
  text-align: right;
  color: #0093b2;
  padding: 0 10px;
`

export const PackOldPriceHeader = styled.div`
  font-family: Ubuntu, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.02em;
  color: #1f1f1f;
  text-decoration: line-through;
`

export const PackageTableTypeText = styled.div`
  color: #0093b2;
`

export const PackageTableTypeIcon = styled.img``

export const PackageTableCellCollapsable = styled(PackageTableCell)`
  text-align: end;
`

export const PackageTableCellCollapsableButton = styled.img`
  cursor: pointer;
  right: 0;
`

export const Checkmark = styled.img`
  display: block;
  margin: auto;
`

export const NoCheckmark = styled.img`
  display: block;
  margin: auto;
`

export const Container = styled.div`
  .messageContainer {
    position: sticky;
    bottom: 90px;
    z-index: 9;
  }

  .accordionWrapperFlex {
    max-width: calc(1440px - 32px);
    padding: 0 24px;
    width: 100%;
    margin: auto;
  }

  .messageContainer,
  .DFaccordionBox {
    text-align: left;
    background-color: ${({ isFullStop }: { isFullStop: boolean }) =>
      isFullStop ? '#ef5350' : '#fc9e00'};
  }
`
